import { Alert, Button, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import type { ClientProductOption, ToggleableClientProductKey } from "./clientProfilesMapping";

interface ToggleableClientProductOption extends ClientProductOption {
  canToggle: true;
}

interface Props {
  configurableProducts: ToggleableClientProductOption[];
  isUpdatingProductState: boolean;
  lastProductConfirmation?: string;
  productUpdateError?: string;
  onRequestProductStateChange: (productKey: ToggleableClientProductKey, productName: string, enabled: boolean) => void;
}

const ClientProfileProductsSection = ({
  configurableProducts,
  isUpdatingProductState,
  lastProductConfirmation,
  productUpdateError,
  onRequestProductStateChange,
}: Props) => {
  return (
    <Stack spacing={1}>
      <Typography variant="h6">Products</Typography>
      {productUpdateError && (
        <Alert severity="error" variant="outlined">
          {productUpdateError}
        </Alert>
      )}
      {lastProductConfirmation && (
        <Alert severity="success" variant="outlined">
          {lastProductConfirmation}
        </Alert>
      )}

      <Stack spacing={1}>
        <Typography variant="subtitle2">Configurable Features</Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Product</TableCell>
              <TableCell>Option</TableCell>
              <TableCell>Controls</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {configurableProducts.map((product) => (
              <TableRow key={product.key}>
                <TableCell>{product.name}</TableCell>
                <TableCell>{product.enabled ? "Enabled" : "Not enabled"}</TableCell>
                <TableCell>
                  <Button
                    disabled={product.enabled || isUpdatingProductState}
                    onClick={() => onRequestProductStateChange(product.key, product.name, true)}
                  >
                    Enable
                  </Button>
                  <Button
                    disabled={!product.enabled || isUpdatingProductState}
                    onClick={() => onRequestProductStateChange(product.key, product.name, false)}
                  >
                    Disable
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Stack>
    </Stack>
  );
};

export default ClientProfileProductsSection;
